import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
const SvgBreadcrumbCaret = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg width={8} height={8} viewBox="0 0 8 8" role="img" ref={ref} {...props}><path fill="#8b8b8b" d="M6.805 4.453 3.173 7.82c-.26.241-.682.241-.943 0s-.26-.632 0-.874l3.16-2.929-3.195-2.961a.586.586 0 0 1 0-.874.704.704 0 0 1 .943 0l3.667 3.398c.26.242.26.633 0 .874z" /></svg>;
const ForwardRef = forwardRef(SvgBreadcrumbCaret);
export default ForwardRef;